module.exports = __webpack_public_path__ + "img/christine-after.779761f4.png";